import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { TellentAppsHttpClient } from './tellent-apps.http';
import { TellentAppsActions } from './tellent-apps.store';

@Injectable({ providedIn: 'root' })
export class TellentAppsEffects {
  private readonly tellentAppHttpClient = inject(TellentAppsHttpClient);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(TellentAppsActions, this.actions$);

  public fetchApps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentAppsActions.fetchCollection),
      switchMap(({ payload }) =>
        this.tellentAppHttpClient.fetchApps().pipe(
          map(({ data }) =>
            TellentAppsActions.fetchCollectionSuccess({
              payload: { data: data },
            }),
          ),
          catchError(error => of(TellentAppsActions.fetchCollectionFailed({ payload: error }))),
        ),
      ),
    ),
  );

  public createApp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TellentAppsActions.createApp),
      switchMap(({ payload }) =>
        this.tellentAppHttpClient.createApp(payload).pipe(
          map(({ data }) =>
            TellentAppsActions.createAppSuccess({
              payload: { data: data },
            }),
          ),
          catchError(({ error }) =>
            of(TellentAppsActions.createAppFailed({ payload: { error: error.errors[0] } })),
          ),
        ),
      ),
    ),
  );
}
